import { render, staticRenderFns } from "./PreviewGallery.vue?vue&type=template&id=7490044d&"
import script from "./PreviewGallery.vue?vue&type=script&lang=ts&"
export * from "./PreviewGallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports